import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import axios from 'utils/axios';

export function useAuthLoader() {
  const { guestPortalId: accessToken } = useParams<{ guestPortalId: string }>();

  const { data, isLoading, error } = useQuery(
    ['GP_ACCESS', accessToken],
    () => axios.get(`/guest_portals/accesses/${accessToken}`).then((data) => data.data),
    { staleTime: 5000 },
  );

  return {
    data,
    isLoading,
    error,
  };
}
